export default __webpack_public_path__ + "assets/images/default-image-author.svg";